module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallH.png
// module id = 244
// module chunks = 0